<article>
  <a mat-list-item [routerLink]="[lecture.$key, 'lessons', lesson.$key]">
    <header matLine>{{ (lesson.name | async)?.$value }}</header>
  </a>
</article>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-list-item/lesson-list-item.component.html